// Color tools - pick, convert (hex/rgb/hsl), generate a palette, check contrast.
import { el, input, field, wrap, copy, btn } from "./ui.js";

const clamp = (n, a, b) => Math.max(a, Math.min(b, n));
const toHex = (n) => clamp(Math.round(n), 0, 255).toString(16).padStart(2, "0");
const rgbToHex = (r, g, b) => "#" + toHex(r) + toHex(g) + toHex(b);
function hexToRgb(hex) { const m = /^#?([0-9a-f]{6})$/i.exec(hex.trim()); if (!m) return null; const n = parseInt(m[1], 16); return [n >> 16 & 255, n >> 8 & 255, n & 255]; }
function rgbToHsl(r, g, b) { r /= 255; g /= 255; b /= 255; const mx = Math.max(r, g, b), mn = Math.min(r, g, b); let h = 0, s = 0; const l = (mx + mn) / 2; const d = mx - mn; if (d) { s = l > 0.5 ? d / (2 - mx - mn) : d / (mx + mn); h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60; } return [Math.round(h), Math.round(s * 100), Math.round(l * 100)]; }
function lum(r, g, b) { const a = [r, g, b].map((v) => { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); }); return 0.2126 * a[0] + 0.7152 * a[1] + 0.0722 * a[2]; }
function shade(hex, amt) { const c = hexToRgb(hex); if (!c) return hex; return rgbToHex(c[0] + (255 - c[0]) * amt, c[1] + (255 - c[1]) * amt, c[2] + (255 - c[2]) * amt); }
function darken(hex, amt) { const c = hexToRgb(hex); if (!c) return hex; return rgbToHex(c[0] * (1 - amt), c[1] * (1 - amt), c[2] * (1 - amt)); }

export function color(root) {
	const s = wrap(root); s.classList.add("rv-color");
	const picker = input("color", { value: "#e9c46a" });
	const hex = input("text", { value: "#e9c46a" });
	const rgb = el("div", "rv-color-readout");
	const hsl = el("div", "rv-color-readout");
	const swatch = el("div", "rv-color-swatch");
	const palette = el("div", "rv-color-palette");

	function setFromHex(h) {
		const c = hexToRgb(h); if (!c) return;
		const norm = rgbToHex(c[0], c[1], c[2]);
		picker.value = norm; hex.value = norm; swatch.style.background = norm;
		rgb.textContent = "rgb(" + c.join(", ") + ")";
		const hh = rgbToHsl(c[0], c[1], c[2]); hsl.textContent = "hsl(" + hh[0] + ", " + hh[1] + "%, " + hh[2] + "%)";
		renderPalette(norm);
	}
	function renderPalette(h) {
		palette.textContent = "";
		[-0.4, -0.2, 0, 0.2, 0.4].map((a) => (a < 0 ? darken(h, -a) : a > 0 ? shade(h, a) : h)).forEach((c) => {
			const sw = el("button", "rv-color-chip"); sw.type = "button"; sw.style.background = c; sw.title = c;
			sw.addEventListener("click", () => { copy(c); sw.classList.add("copied"); setTimeout(() => sw.classList.remove("copied"), 600); });
			palette.appendChild(sw);
		});
	}
	picker.addEventListener("input", () => setFromHex(picker.value));
	hex.addEventListener("input", () => setFromHex(hex.value));
	rgb.addEventListener("click", () => copy(rgb.textContent));
	hsl.addEventListener("click", () => copy(hsl.textContent));

	// contrast checker
	const fg = input("color", { value: "#ffffff" }); const bg = input("color", { value: "#000000" });
	const ratioEl = el("div", "rv-contrast-ratio");
	const preview = el("div", "rv-contrast-preview", "Aa");
	function contrast() {
		const f = hexToRgb(fg.value), b = hexToRgb(bg.value); if (!f || !b) return;
		const L1 = lum(...f), L2 = lum(...b); const ratio = (Math.max(L1, L2) + 0.05) / (Math.min(L1, L2) + 0.05);
		ratioEl.textContent = ratio.toFixed(2) + ":1";
		preview.style.color = fg.value; preview.style.background = bg.value;
		const badge = (ok) => ok ? "✓" : "✕";
		ratioEl.title = "AA " + badge(ratio >= 4.5) + " · AAA " + badge(ratio >= 7);
		ratioEl.dataset.pass = ratio >= 4.5 ? "yes" : "no";
		ratioEl.textContent = ratio.toFixed(2) + ":1  ·  AA " + badge(ratio >= 4.5) + "  AAA " + badge(ratio >= 7);
	}
	[fg, bg].forEach((e) => e.addEventListener("input", contrast));

	const conv = el("div", "rv-color-conv");
	conv.append(swatch, field("Picker", picker), field("Hex", hex), el("div", "rv-color-vals"));
	conv.querySelector(".rv-color-vals").append(rgb, hsl);
	const con = el("div", "rv-contrast");
	con.append(el("h2", "rv-tool-sub", "Contrast checker"), preview, el("div", "rv-trow"), ratioEl);
	con.querySelector(".rv-trow").append(field("Text", fg), field("Background", bg));

	s.append(conv, el("h2", "rv-tool-sub", "Palette"), palette, con);
	setFromHex("#e9c46a"); contrast();
}
